import { createFileRoute } from '@tanstack/react-router'
import { AccountScreen } from '../features/directory/screens'

export const Route = createFileRoute('/accounts/$id')({
  component: AccountRoute,
})

function AccountRoute() {
  const { id } = Route.useParams()
  return <AccountScreen id={id} />
}
